import { useState } from 'react';

export const usePopover = () => {
  const [anchorElement, setAnchorElement] = useState<HTMLDivElement | null>(
    null,
  );

  return {
    anchorElement,
    openPopover: (element: HTMLDivElement | null) => setAnchorElement(element),
    closePopover: () => setAnchorElement(null),
    isOpen: Boolean(anchorElement),
  };
};
